import Index from '@merchant-backend/appraise/src/index'
import SubMerchant from '@merchant-backend/appraise/src/views/SubMerchant'
import QADetail from '@merchant-backend/appraise/src/views/QADetail'
import QAAppeal from '@merchant-backend/appraise/src/views/QAAppeal' //后面可能这部分功能可能会废弃掉搬用老的
import AppraiseAppeal from '@merchant-backend/appraise/src/views/AppraiseAppeal'

export default {
  path: 'appraise',
  indexRoute: {
    component: Index
  },
  childRoutes: [
    // 用于父商家访问子商家的评论列表使用
    {
      path: 'subMerchant',
      component: SubMerchant
    },
    // 问答详情页
    {
      path: 'qa/:id',
      component: QADetail
    },
    // 问答申诉页
    {
      path: 'qa/appeal/:id',
      component: QAAppeal
    },
    // 评价申诉详情页
    {
      path: 'appeal/:id',
      component: AppraiseAppeal
    }
  ]
}
